const breadcrumbsHome = { name: 'Home', pathName: '/home' }
const breadcrumbsMobile = { name: 'Mobile', pathName: null }
const breadcrumbsCampanhas = { name: 'Campanhas', pathName: null, action: 'campanhas' }

export default [
  {
    path: '/campanhas',
    component: () => import('@/modules/campanhas/views/pages/Campanhas.vue'),
    children: [
      {
        path: 'sms',
        name: 'campanhas-sms',
        component: () => import('@/modules/campanhas/campanhas-sms/views/pages/Index.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'SMS',
              pathName: null,
            },
          ],
          title: 'SMS',
          pagePermission: 'campanhas/sms',
        },
      },
      {
        path: 'sms/nova',
        name: 'campanhas-sms-cadastro',
        component: () => import('@/modules/campanhas/campanhas-sms/views/pages/Campaign.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'SMS',
              pathName: '/campanhas/sms',
            },
            {
              name: 'Nova campanha',
              pathName: 'nova',
            },
          ],
          title: 'SMS',
          pagePermission: 'campanhas/sms',
        },
      },
      {
        path: 'sms/:id',
        alias: ['sms/editar/:id'],
        component: () => import('@/modules/campanhas/campanhas-sms/views/pages/Campaign.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'SMS',
              pathName: '/campanhas/sms',
            },
            {
              name: 'Campanha',
              pathName: null,
            },
          ],
          title: 'SMS',
          pagePermission: 'campanhas/sms',
        },
      },
      {
        path: 'sms/resultados/:id',
        component: () => import('@/modules/campanhas/campanhas-sms/views/pages/Results.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'SMS',
              pathName: '/campanhas/sms',
            },
            {
              name: 'Campanha',
              pathName: null,
            },
          ],
          title: 'SMS',
          pagePermission: 'campanhas/sms',
        },
      },
      {
        path: 'email',
        alias: ['email-marketing', 'campanhas-email'],
        component: () => import('@/modules/campanhas/campanhas-email/views/pages/Index.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'E-mail',
              pathName: null,
            },
          ],
          title: 'E-mail',
          permission: 'email_v2',
          pagePermission: 'campanhas/email-v2',
        },
      },
      {
        path: 'email/nova',
        name: 'campanhas-email-cadastro',
        alias: ['email-marketing/nova'],
        component: () => import('@/modules/campanhas/campanhas-email/views/pages/Campaign.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'E-mail',
              pathName: '/campanhas/email',
            },
            {
              name: 'Nova campanha',
              pathName: null,
            },
          ],
          title: 'E-mail',
          permission: 'email_v2',
          pagePermission: 'campanhas/email-v2',
        },
      },
      {
        path: 'email/:id',
        alias: ['email-marketing/:id', 'email/editar/:id'],
        component: () => import('@/modules/campanhas/campanhas-email/views/pages/Campaign.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'E-mail',
              pathName: '/campanhas/email',
            },
            {
              name: 'Campanha',
              pathName: null,
            },
          ],
          title: 'E-mail',
          permission: 'email_v2',
          pagePermission: 'campanhas/email-v2',
        },
      },
      {
        path: 'email/resultados/:id',
        component: () => import('@/modules/campanhas/campanhas-email/views/pages/Results.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'E-mail',
              pathName: '/campanhas/email',
            },
            {
              name: 'Campanha',
              pathName: null,
            },
          ],
          title: 'E-mail',
          permission: 'email_v2',
          pagePermission: 'campanhas/email-v2',
        },
      },
      {
        path: 'aplicativo',
        component: () => import('@/modules/campanhas/campanhas-aplicativo/views/pages/Index.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'Aplicativo',
              pathName: null,
            },
          ],
          title: 'Aplicativo',
          permission: 'push',
          pagePermission: 'campanhas/aplicativo',
        },
      },
      {
        path: 'aplicativo/nova',
        name: 'campanhas-aplicativo-cadastro',
        alias: ['campanhas-aplicativo/nova'],
        component: () => import('@/modules/campanhas/campanhas-aplicativo/views/pages/Campaign.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'Aplicativo',
              pathName: '/campanhas/aplicativo',
            },
            {
              name: 'Nova campanha',
              pathName: 'nova',
            },
          ],
          title: 'Aplicativo',
          permission: 'push',
          pagePermission: 'campanhas/aplicativo',
        },
      },
      {
        path: 'aplicativo/:id',
        alias: ['aplicativo/editar/:id'],
        component: () => import('@/modules/campanhas/campanhas-aplicativo/views/pages/Campaign.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'Aplicativo',
              pathName: '/campanhas/aplicativo',
            },
            {
              name: 'Campanha',
              pathName: null,
            },
          ],
          title: 'Aplicativo',
          permission: 'push',
          pagePermission: 'campanhas/aplicativo',
        },
      },
      {
        path: 'aplicativo/resultados/:id',
        name: 'aplicativo-resultados',
        component: () => import('@/modules/campanhas/campanhas-aplicativo/views/pages/Results.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'Aplicativo',
              pathName: '/campanhas/aplicativo',
            },
            {
              name: 'Campanha',
              pathName: null,
            },
          ],
          title: 'Aplicativo',
          permission: 'push',
          pagePermission: 'campanhas/aplicativo',
        },
      },
      {
        path: 'gestao-ofertas',
        name: 'gestao-ofertas',
        component: () => import('@/modules/campanhas/gestao-ofertas-v2/views/pages/Index.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'Gestão de ofertas',
              pathName: null,
            },
          ],
          title: 'Gestão de ofertas',
          permission: 'offer_management',
          pagePermission: 'campanhas/gestao_ofertas/ofertas',
        },
      },
      {
        path: 'gestao-ofertas/nova',
        component: () => import('@/modules/campanhas/gestao-ofertas-v2/views/pages/Edit.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'Gestão de ofertas',
              pathName: '/campanhas/gestao-ofertas',
            },
            {
              name: 'Nova campanha',
              pathName: null,
            },
          ],
          title: 'Gestão de ofertas',
          permission: 'offer_management',
          pagePermission: 'campanhas/gestao_ofertas/ofertas',
        },
      },
      {
        path: 'gestao-ofertas/:id',
        alias: ['gestao-ofertas/editar/:id'],
        name: 'gestao-ofertas-editar',
        component: () => import('@/modules/campanhas/gestao-ofertas-v2/views/pages/Edit.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'Gestão de ofertas',
              pathName: '/campanhas/gestao-ofertas',
            },
            {
              name: 'Campanha',
              pathName: null,
            },
          ],
          title: 'Gestão de ofertas',
          permission: 'offer_management',
          pagePermission: 'campanhas/gestao_ofertas/ofertas',
        },
      },
      {
        path: 'gestao-ofertas/resultados/:id',
        name: 'gestao-ofertas-resultado',
        component: () => import('@/modules/campanhas/gestao-ofertas-v2/views/pages/Results.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'Gestão de ofertas',
              pathName: '/campanhas/gestao-ofertas',
            },
            {
              name: 'Campanha',
              pathName: null,
            },
          ],
          title: 'Gestão de ofertas',
          permission: 'offer_management',
          pagePermission: 'campanhas/gestao_ofertas/ofertas',
        },
      },
      {
        path: 'gestao-ofertas/historico-consultas/:id',
        name: 'gestao-ofertas-historico-consultas',
        component: () => import('@/modules/campanhas/gestao-ofertas-v2/views/pages/ConsumedSalesSession.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'Gestão de ofertas',
              pathName: '/campanhas/gestao-ofertas',
            },
            {
              name: 'Campanha',
              pathName: null,
            },
          ],
          title: 'Gestão de ofertas',
          permission: 'offer_management',
          pagePermission: 'campanhas/gestao_ofertas/ofertas',
        },
      },
      {
        path: 'resultados-encarte',
        component: () => import('@/modules/campanhas/resultados-encarte/views/pages/ResultadosEncarte.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'Resultados de encarte',
              pathName: null,
            },
          ],
          title: 'Resultados de encarte',
          pagePermission: 'campanhas/resultados_encarte',
        },
      },
      {
        path: 'whatsapp',
        component: () => import('@/modules/campanhas/whatsapp/views/pages/Whatsapp.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'WhatsApp',
              pathName: null,
            },
          ],
          title: 'WhatsApp',
          permission: 'whatsapp',
          pagePermission: 'campanhas/whatsapp',
        },
      },
      {
        path: 'whatsapp/nova',
        name: 'campanhas-whatsapp-cadastro',
        component: () => import('@/modules/campanhas/whatsapp/views/pages/AlteracaoCampanhaWhatsapp.vue'),
        props: { newCampaign: true },
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'WhatsApp',
              pathName: '/campanhas/whatsapp',
            },
            {
              name: 'Nova Campanha',
              pathName: null,
            },
          ],
          title: 'WhatsApp',
          permission: 'whatsapp',
          pagePermission: 'campanhas/whatsapp',
        },
      },
      {
        path: 'whatsapp/editar/:id',
        name: 'campanhas-whatsapp-editar',
        component: () => import('@/modules/campanhas/whatsapp/views/pages/AlteracaoCampanhaWhatsapp.vue'),
        props: { newCampaign: false },
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'WhatsApp',
              pathName: '/campanhas/whatsapp',
            },
            {
              name: 'Editar campanha',
              pathName: null,
            },
          ],
          title: 'WhatsApp',
          permission: 'whatsapp',
          pagePermission: 'campanhas/whatsapp',
        },
      },
      {
        path: 'whatsapp/resultados/:id',
        name: 'whatsapp-resultados',
        component: () => import('@/modules/campanhas/whatsapp/views/pages/Results.vue'),
        meta: {
          breadcrumbs: [
            {
              name: 'Home',
              pathName: '/home',
            },
            {
              name: 'Campanhas',
              pathName: null,
              action: 'campanhas',
            },
            {
              name: 'WhatsApp',
              pathName: '/campanhas/whatsapp',
            },
            {
              name: 'Resultados de campanha WhatsApp',
              pathName: null,
            },
          ],
          title: 'WhatsApp',
          permission: 'whatsapp',
          pagePermission: 'campanhas/whatsapp',
        },
      },
      {
        path: 'resultados-gerais',
        component: () => import('@/modules/campanhas/resultados-gerais/pages/views/Index.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'Resultados Gerais',
              pathName: null,
            },
          ],
          title: 'Resultados Gerais',
          pagePermission: 'campanhas/resultados_gerais',
        },
      },
      {
        path: 'cupom-desconto',
        name: 'cupom-desconto',
        component: () => import('@/modules/campanhas/cupom-desconto/views/pages/Index.vue'),
        meta: {
          breadcrumbs: [
            {
              name: 'Home',
              pathName: '/home',
            },
            {
              name: 'Campanhas',
              pathName: null,
              action: 'campanhas',
            },
            {
              name: 'Cupom de desconto',
              pathName: '/campanhas/cupom-desconto',
            },
          ],
          title: 'Cupom de desconto',
          pagePermission: 'campanhas/cupom_desconto',
        },
      },
      {
        path: 'cupom-desconto/nova',
        name: 'cupom-desconto-nova',
        component: () => import('@/modules/campanhas/cupom-desconto/views/pages/Edit.vue'),
        props: { newCampaign: true },
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'Cupom de desconto',
              pathName: '/campanhas/cupom-desconto',
            },
            {
              name: 'Nova campanha',
              pathName: null,
            },
          ],
          title: 'Cupom de desconto',
          pagePermission: 'campanhas/cupom_desconto',
        },
      },
      {
        path: 'cupom-desconto/:id',
        name: 'cupom-desconto-editar',
        component: () => import('@/modules/campanhas/cupom-desconto/views/pages/Edit.vue'),
        props: { newCampaign: false },
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'Cupom de desconto',
              pathName: '/campanhas/cupom-desconto',
            },
            {
              name: 'Editar campanha',
              pathName: null,
            },
          ],
          title: 'Cupom de desconto',
          pagePermission: 'campanhas/cupom_desconto',
        },
      },
      {
        path: 'cupom-desconto/resultados/:id',
        name: 'cupom-desconto-resultados',
        component: () => import('@/modules/campanhas/cupom-desconto/views/pages/Results.vue'),
        meta: {
          breadcrumbs: [
            {
              name: 'Home',
              pathName: '/home',
            },
            {
              name: 'Campanhas',
              pathName: null,
              action: 'campanhas',
            },
            {
              name: 'Cupom de desconto',
              pathName: '/campanhas/cupom-desconto',
            },
          ],
          title: 'Cupom de Desconto',
          pagePermission: 'campanhas/cupom_desconto',
        },
      },
      {
        path: 'cupom-desconto/historico-utilizacao/:id',
        name: 'cupom-historico-utilizacao',
        component: () => import('@/modules/campanhas/cupom-desconto/views/pages/UsageHistory.vue'),
        meta: {
          breadcrumbs: [
            {
              name: 'Home',
              pathName: '/home',
            },
            {
              name: 'Campanhas',
              pathName: null,
              action: 'campanhas',
            },
            {
              name: 'Cupom de desconto',
              pathName: '/campanhas/cupom-desconto',
            },
          ],
          title: 'Cupom de Desconto',
          pagePermission: 'campanhas/cupom_desconto',
        },
      },
      {
        path: 'whatsapp/fluxos/novo',
        name: 'whatsapp-fluxos-novo',
        component: () => import('@/modules/campanhas/whatsapp/views/pages/Flow.vue'),
        props: { newFlowMenu: true },
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'WhatsApp',
              pathName: '/campanhas/whatsapp',
            },
            {
              name: 'Novo Fluxo',
              pathName: null,
            },
          ],
          title: 'WhatsApp - Fluxos',
          permission: 'whatsapp',
          pagePermission: 'campanhas/whatsapp',
        },
      },
      {
        path: 'whatsapp/fluxos/editar/:id',
        name: 'whatsapp-fluxos-editar',
        component: () => import('@/modules/campanhas/whatsapp/views/pages/Flow.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsCampanhas,
            {
              name: 'WhatsApp',
              pathName: '/campanhas/whatsapp',
            },
            {
              name: 'Editar Fluxo',
              pathName: null,
            },
          ],
          title: 'WhatsApp - Fluxos',
          permission: 'whatsapp',
          pagePermission: 'campanhas/whatsapp',
        },
      },
      {
        path: 'destaques/novo',
        name: 'destaques-fluxos-novo',
        component: () => import('@/modules/mobile/destaques/views/pages/Campaign.vue'),
        props: { newCampaign: true },
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMobile,
            {
              name: 'Destaques',
              pathName: '/mobile/destaques',
            },
            {
              name: 'Novo destaque',
              pathName: null,
            },
          ],
          title: 'Novo destaque',
          pagePermission: 'mobile/destaques',
        },
      },
      {
        path: 'destaques/resultados/:id',
        name: 'destaques-resultados',
        component: () => import('@/modules/mobile/destaques/views/pages/Results.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMobile,
            {
              name: 'Destaques',
              pathName: '/mobile/destaques',
            },
            {
              name: 'Resultados',
              pathName: null,
            },
          ],
          title: 'Resultados de Destaques',
          pagePermission: 'mobile/destaques',
        },
      },
    ],
  },
]
